module.exports = __webpack_public_path__ + "static/media/share_bg.c4f01626.png";